import { Add, Edit, Delete } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { createAxios } from "../../common/axios";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { ReplacementArticleDialog } from "./ReplacementArticleDialog";
import { ReplacementArticleDto } from "./types";
import { EnumItemDto } from "../../common/enum";

export function ReplacementArticleListPage() {
    const [useSaleArticlesStore] = useState(() => createListStore<EnumItemDto>({ path: "settings/replacementArticles/saleArticles" }));
    const [useStore] = useState(() => createListStore<ReplacementArticleDto>({
        path: "settings/replacementArticles",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "saleArticleId", label: "Sales article", width: 350, enumStore: useSaleArticlesStore },
            { column: "price", label: "Price", width: 120, type: "currency" },
            { column: "description", label: "Description", width: 350 },
            { column: "isActive", label: "Active", width: 120, type: "bool" },
        ],
    }));

    const { selectedItem } = useStore(p => ({ selectedItem: p.selectedItem }));
    const simpleDialog = useSimpleDialog();
    async function deleteSelectedItem() {
        await simpleDialog.show("Delete replacement article", "Delete selected replacement article?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`settings/replacementArticles/${selectedItem!.id}`);
            }
            finally {
                useStore.getState().fetch();
            }
        }));
    }
    const newDialog = useDialog(close => <ReplacementArticleDialog close={close} replacementArticle={null} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} useSaleArticlesStore={useSaleArticlesStore} />, "lg");
    const editDialog = useDialog(close => <ReplacementArticleDialog close={close} replacementArticle={selectedItem!} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} useSaleArticlesStore={useSaleArticlesStore} />, "lg");
    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <PageTitle title="Replacement articles" />
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={selectedItem == null} title="Delete" onClick={deleteSelectedItem}><Delete /></Button>],
            ]),
            getRowClass: p => p.isActive ? ["greenRibbon"] : ["redRibbon"],
        })}
    </>;
}
